(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39848],{

/***/ 43244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unsat-terms",
      function () {
        return __webpack_require__(91686);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PIP_ERROR_CODE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73060);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85780);






var PIP_ERROR_CODE = "E5222";
var usePartPaymentStatus = function(goalUID) {
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID && isLoggedIn ? "v1/subscriptions/pay_in_parts_subscription_details?goal_uid=".concat(goalUID) : null), data = _ref.data, error = _ref.isError, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, [
        "data",
        "isError"
    ]);
    var partPaymentStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (data) return data;
        if ((error === null || error === void 0 ? void 0 : error.error_code) === PIP_ERROR_CODE) return error;
        return null;
    }, [
        data,
        error
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        partPaymentStatus: partPaymentStatus
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePartPaymentStatus);


/***/ }),

/***/ 81648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _base_H5_H5__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43807);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85620);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);






var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1vn1sgz0",
    label: "Container"
})("display:flex;flex-direction:column;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_10B */ .t8.FC, ";");
var Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H5_H5__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1vn1sgz1",
    label: "Title"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var StyledUl = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("ul", {
    target: "e1vn1sgz2",
    label: "StyledUl"
})("list-style:none;padding-left:0px;");
var StyledP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e1vn1sgz3",
    label: "StyledP1"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";color:var(--color-i-blue);display:inline-block;");
var ContentsTable = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Container, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Title, {
                children: "Table of contents :"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledUl, {
                children: data.map(function(dataItem, index) {
                    var label = dataItem.label, id = dataItem.id;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                            href: "#".concat(id),
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledP1, {
                                children: label
                            })
                        })
                    }, String(index));
                })
            })
        ]
    });
};
ContentsTable.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentsTable);


/***/ }),

/***/ 39396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h2", {
    target: "e1ty00a50",
    label: "H2"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H2 */ .F3.H2, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.PARA_LINE_HEIGHT */ .F3.MA, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:22px;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H2);
H2.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H2.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 82034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H3 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h3", {
    target: "e1121ic30",
    label: "H3"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H3 */ .F3.H3, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.PARA_LINE_HEIGHT */ .F3.MA, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:22px;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H3);
H3.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H3.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 37957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85620);
/* harmony import */ var _base_H5_H5__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43807);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76356);







var StyledUl = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("ul", {
    target: "ets1db00",
    label: "StyledUl"
})("list-style:none;padding-left:0px;");
var StyledLi = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("li", {
    target: "ets1db01",
    label: "StyledLi"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_3B */ .t8.N, ";");
var MenusNav = function(param) {
    var data = param.data, currentHref = param.currentHref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledUl, {
        children: data.map(function(dataItem, index) {
            var label = dataItem.label, url = dataItem.url;
            var isSelected = url.href === currentHref;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledLi, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    href: url.href,
                    as: url.as,
                    children: isSelected ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_H5_H5__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        children: label
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        color: "var(--color-text-secondary)",
                        children: label
                    })
                })
            }, String(index));
        })
    });
};
MenusNav.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_6___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_6___default().any)).isRequired,
    currentHref: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (MenusNav);


/***/ }),

/***/ 27300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52420);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16050);
/* harmony import */ var _context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9716);




var PageReduxProvider = function(param) {
    var children = param.children, initialReduxState = param.initialReduxState;
    var store = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .getStore */ .b)(initialReduxState);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        store: store,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PageReduxProvider);


/***/ }),

/***/ 71750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var LeftContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1tonlag0",
    label: "LeftContainer"
})("grid-column:1/6;position:sticky;top:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_HEADER */ .t8.bu, "px;height:fit-content;", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{display:none;}");
/* harmony default export */ __webpack_exports__["Z"] = (LeftContainer);


/***/ }),

/***/ 69045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var RightContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1yrx6nt0",
    label: "RightContainer"
})("grid-column:6/25;", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{grid-column:1/25;margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_4B */ .t8.BM, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
/* harmony default export */ __webpack_exports__["Z"] = (RightContainer);


/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ greetingTopSpacing; },
/* harmony export */   "Cj": function() { return /* binding */ eventPadding; },
/* harmony export */   "Du": function() { return /* binding */ timelineTopSpacing; },
/* harmony export */   "EV": function() { return /* binding */ GTP_SUBSCRIPTION; },
/* harmony export */   "UA": function() { return /* binding */ PLATFORM_SUBSCRIPTION; },
/* harmony export */   "UI": function() { return /* binding */ plannerItemTypeHeightMap; },
/* harmony export */   "ZL": function() { return /* binding */ dayTitleLeftSpacing; },
/* harmony export */   "cX": function() { return /* binding */ browseTopSpacing; },
/* harmony export */   "eg": function() { return /* binding */ PLUS_SUBSCRIPTION; },
/* harmony export */   "et": function() { return /* binding */ plannerItemTypes; },
/* harmony export */   "iH": function() { return /* binding */ eventHeightMap; },
/* harmony export */   "jb": function() { return /* binding */ classCardHeight; },
/* harmony export */   "z1": function() { return /* binding */ eventTopSpacing; }
/* harmony export */ });
/* unused harmony export daySpacing */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _constants_schedule__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88268);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var plannerItemTypes = {
    EVENT: "event",
    TIMELINE: "timeline",
    DAY_TITLE: "day_title",
    GREETING: "greeting",
    SUBSCRIPTION_FEEDBACK: "subscription_feedback",
    SUBSCRIPTION_RENEWAL: "renewal_card",
    FEATURE_CARD: "feature_card",
    FEATURE_INTRODUCTION: "feature_introduction",
    FEATURE_AWARENESS: "feature_card",
    BROWSE: "browse",
    SUBSCRIPTION_FEEDBACK_V2: "subscription_feedback_v2",
    FREE_TRIAL_CARD: "trial_subscription",
    SKELETON_LOADER: "skeleton_loader"
};
var daySpacing = 20;
var timelineTopSpacing = 24;
var eventTopSpacing = 24;
var browseTopSpacing = 24;
var greetingTopSpacing = 20;
var classCardHeight = 162;
var dayTitleLeftSpacing = _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_7B */ .t8.d5;
var _obj;
var plannerItemTypeHeightMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.DAY_TITLE, 64), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.TIMELINE, 12 + timelineTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.BROWSE, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.GREETING, 72 + greetingTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_RENEWAL, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_INTRODUCTION, 168 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_AWARENESS, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SKELETON_LOADER, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FREE_TRIAL_CARD, 212 + browseTopSpacing), _obj);
var _obj1;
var eventHeightMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS */ .pt.CLASS, classCardHeight + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS_WITH_PRACTICE */ .pt.CLASS_WITH_PRACTICE, 222 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST */ .pt.TEST, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST_WITH_EDUCATOR */ .pt.TEST_WITH_EDUCATOR, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.QUIZ */ .pt.QUIZ, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.COMBAT */ .pt.COMBAT, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.LIVE_INTERACTION */ .pt.LIVE_INTERACTION, 98 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.DAILY_PRACTICE_REMINDER */ .pt.DAILY_PRACTICE_REMINDER, 84 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OPENHOUSE */ .pt.OPENHOUSE, 80 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OFFLINE_TEST */ .pt.OFFLINE_TEST, 136 + eventTopSpacing), _obj1);
var eventPadding = 16;
var PLUS_SUBSCRIPTION = "plus_subscription";
var PLATFORM_SUBSCRIPTION = "platform_subscription";
var GTP_SUBSCRIPTION = "gtp_subscription";


/***/ }),

/***/ 88322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ DAILY_GOALS_OPTIONS; },
/* harmony export */   "Fj": function() { return /* binding */ DPP_SET_REMINDER_CLICKED; },
/* harmony export */   "G8": function() { return /* binding */ TOOLTIP_MAP; },
/* harmony export */   "Jb": function() { return /* binding */ DPP_COMPLETED; },
/* harmony export */   "Jf": function() { return /* binding */ QUERY_ACTIONS; },
/* harmony export */   "Kd": function() { return /* binding */ MAX_PRACTICE_SESSION_COUNT; },
/* harmony export */   "LJ": function() { return /* binding */ DISLIKE_REASONS; },
/* harmony export */   "Lr": function() { return /* binding */ MIN_QUESTIONS; },
/* harmony export */   "MA": function() { return /* binding */ FEEDBACK_OPTIONS_MAPPING; },
/* harmony export */   "Ny": function() { return /* binding */ MODAL_TYPES; },
/* harmony export */   "R1": function() { return /* binding */ DPP_SET_REMINDER_CARD_VIEWED; },
/* harmony export */   "Sx": function() { return /* binding */ YEAR_FILTER_TYPE; },
/* harmony export */   "Up": function() { return /* binding */ noPrefrenceCode; },
/* harmony export */   "VL": function() { return /* binding */ REVIEW_TYPE; },
/* harmony export */   "Ws": function() { return /* binding */ PRACTICE_TYPE; },
/* harmony export */   "Xg": function() { return /* binding */ TIME_LAPSE_LIMIT; },
/* harmony export */   "Y8": function() { return /* binding */ practiceActionTypes; },
/* harmony export */   "ad": function() { return /* binding */ LANGUAGE; },
/* harmony export */   "cq": function() { return /* binding */ PRACTICE_MIN_QUESTION_NUM; },
/* harmony export */   "gi": function() { return /* binding */ DEFAULT_LANGUAGE_INFO; },
/* harmony export */   "jb": function() { return /* binding */ DEFAULT_DAILY_GOAL; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lz": function() { return /* binding */ DAILY_REMINDER_OPTIONS; },
/* harmony export */   "nI": function() { return /* binding */ PRACTICE_FLOW_TYPE; },
/* harmony export */   "oH": function() { return /* binding */ DPP_INCOMPLETE; },
/* harmony export */   "oZ": function() { return /* binding */ SKIP_REASONS; },
/* harmony export */   "pj": function() { return /* binding */ DEFAULT_TIME; },
/* harmony export */   "qu": function() { return /* binding */ DEFAULT_TIME_IN_TEXT; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
/* unused harmony exports getHoursOptions, getRoundedGTPPracticeQuestionCount, DPP_PREFERENCES_QUESTION, PRACTICE_SETTINGS_CLICKED */
/* harmony import */ var _constants_practice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);



var noPrefrenceCode = -1;
var LANGUAGE = {
    ALL: {
        display_name: "All",
        code: 0
    }
};
var DEFAULT_LANGUAGE_INFO = {
    user_preference: 0,
    available_languages: [],
    language_selection_available: false
};
var PRACTICE_TYPE = {
    FULL: 1,
    EACH_TOPIC: 2,
    PYQ: 3,
    TEXTBOOK: 4,
    INCORRECT: 5
};
var PRACTICE_FLOW_TYPE = {
    NORMAL_PRACTICE: "1",
    CLASS_PRACTICE: "2",
    SYLLABUS_PRACTICE: "3",
    AUTO_DPP: "4"
};
var DISLIKE_REASONS = [
    "Mistake in the question/option choices",
    "Mistake in solution",
    "Technical issue",
    "Plagiarism"
];
var YEAR_FILTER_TYPE = {
    ALL: "all-filter"
};
var SKIP_REASONS = [
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIFFICULT_QUESTION */ .X.DIFFICULT_QUESTION,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/thinking-face.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIDNT_UNDERSTAND */ .X.DIDNT_UNDERSTAND,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/confused.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.HAVENT_STUDIED */ .X.HAVENT_STUDIED,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/exclamation-question.svg")
    }
];
var REVIEW_TYPE = {
    POSITIVE: 1,
    NEGATIVE: 2
};
var SUBJECTS = {
    ALL: -1
};
var MAX_QUESTIONS = 30;
var MIN_QUESTIONS = 5;
var FEEDBACK_OPTIONS_MAPPING = {
    POSITIVE: {
        QUALITY_OF_SOLUTIONS: 496,
        QUALITY_OF_QUESTIONS: 497,
        MIX_OF_QUESTIONS: 498,
        INTERFACE: 499,
        SYLLABUS: 500
    },
    NEGATIVE: {
        QUALITY_OF_SOLUTIONS: 501,
        QUALITY_OF_QUESTIONS: 502,
        MIX_OF_QUESTIONS: 503,
        INTERFACE: 504,
        SYLLABUS: 505
    }
};
var DAILY_GOALS_OPTIONS = [
    {
        value: 10,
        label: "10 questions"
    },
    {
        value: 20,
        label: "20 questions"
    },
    {
        value: 30,
        label: "30 questions"
    }
];
var getHoursOptions = function() {
    var options = [];
    var ref = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .generateHours */ .SA)({
        interval: 30
    }), twentyFourHrFormat = ref.twentyFourHrFormat, twelveHrFormat = ref.twelveHrFormat;
    twelveHrFormat.forEach(function(hour, index) {
        options.push({
            value: twentyFourHrFormat[index],
            label: hour
        });
    });
    return options;
};
var DAILY_REMINDER_OPTIONS = getHoursOptions();
var MODAL_TYPES = {
    PRACTICE_REMINDER: "PRACTICE_REMINDER"
};
var QUERY_ACTIONS = {
    SHOW_REMINDER_SETTING: "show_reminder_setting"
};
var TOOLTIP_MAP = {
    TOTAL_QUESTION_LIMIT_REACHED: "Total questions limit reached",
    CANNOT_ADD_MORE_QUESTIONS: "Cannot add more questions",
    NULL: ""
};
var PRACTICE_MIN_QUESTION_NUM = 5;
var getRoundedGTPPracticeQuestionCount = function(count) {
    return Math.floor(count / 100) * 100;
};
var practiceActionTypes = {
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA"
};
var MAX_PRACTICE_SESSION_COUNT = 5;
var TIME_LAPSE_LIMIT = 7;
var DEFAULT_DAILY_GOAL = 10;
var DEFAULT_TIME = "09:00";
var DEFAULT_TIME_IN_TEXT = "09:00 AM";
var DPP_SET_REMINDER_CARD_VIEWED = "DPP - Set Reminder Card Viewed ";
var DPP_SET_REMINDER_CLICKED = "DPP - Set Reminder Clicked";
var DPP_PREFERENCES_QUESTION = "DPP - Preferences Question";
var PRACTICE_SETTINGS_CLICKED = "Practice - Settings Clicked";
var DPP_COMPLETED = 1;
var DPP_INCOMPLETE = 0;


/***/ }),

/***/ 11238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SKIP_REASONS_MAP; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var SKIP_REASONS_MAP = {
    DIFFICULT_QUESTION: "Difficult Question",
    DIDNT_UNDERSTAND: "Didn't Understand",
    HAVENT_STUDIED: "Haven't studied"
};


/***/ }),

/***/ 88268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JL": function() { return /* binding */ ScheduleItemTypeLabel; },
/* harmony export */   "Tc": function() { return /* binding */ scheduleItemStatus; },
/* harmony export */   "ft": function() { return /* binding */ ScheduleItemStatusLabel; },
/* harmony export */   "hc": function() { return /* binding */ scheduleItemTypes; },
/* harmony export */   "pt": function() { return /* binding */ plannerEventTypes; }
/* harmony export */ });
/* unused harmony export ScheduleItemRankLabel */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var scheduleItemStatus = {
    MISSED: 1,
    WATCHED_OR_ATTEMPTED: 2,
    UPCOMING: 3,
    CANCELLED: 4
};
var _obj;
var ScheduleItemStatusLabel = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.MISSED, "missed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.WATCHED_OR_ATTEMPTED, "completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.UPCOMING, "upcoming"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.CANCELLED, "cancelled"), _obj);
var scheduleItemTypes = {
    CLASS: 1,
    QUIZ: 2,
    COMBAT: 3,
    TEST: 4,
    LIVE_INTERACTION: 5,
    OPENHOUSE: 6,
    DAILY_PRACTICE_REMINDER: 7
};
var _obj1;
var ScheduleItemTypeLabel = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.CLASS, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.CLASS */ .cs.CLASS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.QUIZ, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.QUIZ */ .cs.QUIZ), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.TEST, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.TEST */ .cs.TEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.COMBAT, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.COMBAT */ .cs.COMBAT), _obj1);
var _obj2;
var ScheduleItemRankLabel = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.CLASS, "Lesson"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.QUIZ, "Quiz"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.COMBAT, "Combat"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.TEST, "Test"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.LIVE_INTERACTION, "Live Interaction"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.OPENHOUSE, "Openhouse"), _obj2);
// categorized based on their height
var plannerEventTypes = {
    CLASS: "class",
    CLASS_WITH_PRACTICE: "class_with_practice",
    TEST: "test",
    TEST_WITH_EDUCATOR: "test_with_educator",
    QUIZ: "quiz",
    COMBAT: "combat",
    LIVE_INTERACTION: "live_interaction",
    DAILY_PRACTICE_REMINDER: "daily_practice_reminder",
    OPENHOUSE: "openhouse",
    OFFLINE_TEST: "offline_test"
};


/***/ }),

/***/ 56046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ getTopicGroup; },
/* harmony export */   "Bc": function() { return /* binding */ isSummitClass; },
/* harmony export */   "PN": function() { return /* binding */ isCompleted; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Zz": function() { return /* binding */ isUpcoming; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "fr": function() { return /* binding */ isOngoing; },
/* harmony export */   "k$": function() { return /* binding */ getInfoString; },
/* harmony export */   "mI": function() { return /* binding */ getDefaultThumbnail; }
/* harmony export */ });
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46571);




var getInfoString = function(course) {
    var liveAt = course.liveAt || course.startsAt;
    if (!liveAt) return "";
    var infoString = "";
    if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.COMPLETED */ .MZ.COMPLETED) {
        infoString = "".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getTimeFormatInShortFormWithoutSecs */ .ZP.getTimeFormatInShortFormWithoutSecs(course.lessonDuration));
    } else if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.LIVE */ .MZ.LIVE) {
        infoString = "Started on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    }
    infoString = "Starts on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    return infoString;
};
var isUpcoming = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() > now.getTime();
};
var getDefaultThumbnail = function(course) {
    // To not show plus thumbnail if it's a free course
    if ((course.for_plus || course.forPlus) !== false && (course.programme_type || course.programmeType) === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES) {
        return "https://static.uacdn.net/thumbnail/course/testseries-placeholder.png";
    }
    return null;
};
var isOngoing = function(startsAt, endsAt) {
    if (!startsAt || !endsAt) return false;
    var now = new Date();
    return new Date(startsAt).getTime() < now.getTime() && new Date(endsAt).getTime() > now.getTime();
};
var isCompleted = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() < now.getTime();
};
var isSummitClass = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return ((ref = data.goal) === null || ref === void 0 ? void 0 : ref.uid) === "DCGBT";
};
function courseModel(course) {
    var ref, ref1, ref2, ref3, ref4;
    var topicGroups = course.topic_groups || [
        course.topic_group
    ];
    var _state;
    var data = {
        uid: course.uid,
        name: course.name,
        isPartOfBatch: course.is_part_of_batch,
        thumbnail: course.cover_photo_v1 || course.thumbnail_v1 || course.thumbnail || course.cover_photo || getDefaultThumbnail(course),
        newThumbnail: course.cover_photo_v1,
        description: course.description || null,
        permalink: course.permalink,
        relativeLink: course.relative_link,
        averageRating: course.avg_rating,
        slug: course.slug,
        isActive: course.is_active,
        totalReviews: course.total_reviews,
        totalRatings: course.total_ratings,
        forPlus: course.for_plus || course.for_subscription,
        forSubscription: course.for_subscription,
        livestreamUrl: course.livestream_url,
        totalTime: course.total_time,
        totalSessionTime: course.total_session_time,
        viewCount: course.view_count,
        savedCount: course.saved_count,
        previewVideo: course.intro_video,
        language: (course === null || course === void 0 ? void 0 : course.language_display) || (course === null || course === void 0 ? void 0 : (ref = course.multiple_language_display) === null || ref === void 0 ? void 0 : ref[0]),
        liveClassCount: course.sessions_count,
        isEnrolled: course.is_enrolled,
        isBookmarked: course.bookmarked,
        isSpecial: course.is_special,
        isIconic: course.is_iconic,
        enrollmentCount: course.enrollment_count,
        secondaryType: course.secondary_type,
        courseType: course.programme_type,
        isLive: course.is_live,
        state: (_state = course.state) !== null && _state !== void 0 ? _state : course.status,
        liveClassesRemaining: course.sessions_remaining,
        itemCount: course.all_item_count || course.item_count,
        lessonsWatched: course.lessons_watched,
        lessonsCompleted: course.lessons_completed,
        startsAt: course.starts_at,
        endsAt: course.ends_at,
        isUpcoming: isUpcoming(course.starts_at),
        isOngoing: isOngoing(course.starts_at, course.ends_at),
        isCompleted: course.is_completed || isCompleted(course.ends_at),
        quizCount: course.all_item_count - course.sessions_count,
        channelDetails: course.channel,
        nextTrack: {
            item: course.next_track || course.next_session || course.next_class || course.next_item
        },
        previousTrack: {
            item: course.previous_session
        },
        authors: course.authors ? course.authors.map(function(author) {
            return {
                user: author
            };
        }) : [
            {
                user: course.author
            }
        ],
        topicGroups: topicGroups ? topicGroups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        topic: course === null || course === void 0 ? void 0 : (ref1 = course.topic_groups) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
        conceptTopology: course === null || course === void 0 ? void 0 : (ref3 = course.concept_topology) === null || ref3 === void 0 ? void 0 : ref3.name,
        coverPhoto: course.cover_photo_v1 || course.cover_photo || course.thumbnail || getDefaultThumbnail(course),
        colorCode: course.color_code,
        goal: course.goal ? {
            topology: course.goal
        } : null,
        topologies: course.topologies ? course.topologies.map(function(topologyItem) {
            return {
                topology: topologyItem
            };
        }) : null,
        goalUid: course.goal_uid || ((ref4 = course.goal) === null || ref4 === void 0 ? void 0 : ref4.uid) || null,
        liveClasses: course.live_classes ? course.live_classes.map(function(itemData) {
            return {
                item: itemData
            };
        }) : null,
        tag: course.tag,
        unLiveUrl: course.unlive_url,
        progress: course.progress,
        conceptLessonCount: course.lesson_count,
        ogImage: course.og_image || null,
        type: course.type || "",
        voiceLanguages: course.voiceLanguages,
        contentSlideLanguages: course.contentSlideLanguages,
        batchGroup: course.batch_group || null,
        totalDPPCount: (course === null || course === void 0 ? void 0 : course.total_practice_dpp_count) || 0,
        queryID: course.queryID,
        requestID: course.requestID,
        index: course.index,
        isRecordedClassesOnlyCourse: !course.is_live_class_present
    };
    if (course.progress) {
        data.progress.nextLessonRelativeLink = course.progress.next_lesson_relative_link;
        data.progress.isCompleted = parseInt(course.progress.percentage, 2) === 100;
    }
    if (course.programme) {
        data.isRecordedClassesOnlyCourse = !course.programme.is_live_class_present;
    }
    data.infoString = getInfoString(data);
    return data;
}
function getEntityData(data) {
    return courseModel(data);
}
var getTopicGroup = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.topicGroups ? data.topicGroups[0] : null;
};
var getAuthorsName = function(authors) {
    if (!authors) return "";
    var nameText = authors.slice(0, 3).reduce(function(initial, educator, index) {
        if (index === 1) return initial + educator.name;
        if (index < 2 && authors.length === 1) return initial + educator.name;
        if (index < 2) return "".concat(initial, " ").concat(educator.name, ", ");
        return "".concat(initial, " and ").concat(authors.length - 2, " more");
    }, "");
    return nameText;
};
var getLinkPath = function(data) {
    // if course is special
    if (data.isSpecial || data.showAsLesson) {
        var ref, ref1;
        // if a course is special class and inside properties of nextTrack/nextSession uid and relativeLink is available then use class link instead of course link to save redirect from course to class
        var nextTrack = data.nextTrack;
        if (nextTrack && ((nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.uid) || (nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.properties) === null || ref === void 0 ? void 0 : ref.uid) && (nextTrack === null || nextTrack === void 0 ? void 0 : (ref1 = nextTrack.properties) === null || ref1 === void 0 ? void 0 : ref1.relativeLink))) {
            return "/class/[slug]/[uid]";
        }
        return "/course/[slug]/[courseUID]";
    }
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    // lesson - Free course
    if (!forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    // checking whether the passed object is course or item. (item)
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST) {
        // if item and plus item means a class
        if (forPlus) return "/class/[slug]/[uid]";
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/[slug]/[courseUID]/";
    }
    return "/course/[slug]/[courseUID]/";
};
var getLink = function(data) {
    if (data.isSpecial || data.showAsLesson) return (0,_Item__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(data);
    if (!data.forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return data.progress.nextLessonRelativeLink;
    }
    var slug = data.slug;
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    if (!slug) {
        var ref;
        var courseName = (ref = data.name) === null || ref === void 0 ? void 0 : ref.replace(/\/|\\/g, " ");
        slug = _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStringWordsJoinedWith */ .ZP.getStringWordsJoinedWith(courseName, "-");
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/".concat(slug, "/").concat(data.uid);
    }
    return "/".concat(type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST ? forPlus && "class" || "lesson" : "course", "/").concat(slug, "/").concat(data.uid);
};
var course = {
    Course: courseModel,
    getEntityData: getEntityData,
    getAuthorsName: getAuthorsName,
    getTopicGroup: getTopicGroup,
    getLink: getLink,
    getLinkPath: getLinkPath,
    isSummitClass: isSummitClass
};
/* harmony default export */ __webpack_exports__["ZP"] = (course);


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getTopicLinkHref; },
/* harmony export */   "EN": function() { return /* binding */ getSpecialClassesLinkHref; },
/* harmony export */   "Ho": function() { return /* binding */ getHrefAndAsOfAFreeCourse; },
/* harmony export */   "Hw": function() { return /* binding */ getLinkHref; },
/* harmony export */   "Lb": function() { return /* binding */ getSpecialClassesLink; },
/* harmony export */   "Po": function() { return /* binding */ getSpecialClassesAllLink; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "TW": function() { return /* binding */ getCoursesHref; },
/* harmony export */   "UP": function() { return /* binding */ getBrowseLink; },
/* harmony export */   "_Y": function() { return /* binding */ getYoutubeLessonLink; },
/* harmony export */   "b4": function() { return /* binding */ getCoursesAsPath; },
/* harmony export */   "bU": function() { return /* binding */ getYoutubeCourseLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "dF": function() { return /* binding */ getTopicListLink; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "pA": function() { return /* binding */ getTopicLink; },
/* harmony export */   "s3": function() { return /* binding */ getTopicListHref; },
/* harmony export */   "v9": function() { return /* binding */ getGtpFreeClassesAllLink; },
/* harmony export */   "vX": function() { return /* binding */ getHrefAndAsOfSaved; },
/* harmony export */   "vx": function() { return /* binding */ getPannerLink; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports topologyModal, getBrowseLinkAs, getBrowseLinkHref, getPlannerLinkAs, plannerLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);



function topologyModal(topology) {
    var ref;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    return {
        uid: topology.uid,
        name: topology.name,
        permalink: topology.permalink,
        relativeLink: topology.relative_link,
        goalSlug: topology.slug,
        title: topology.title,
        coursesCount: topology.courses_count || topology.item_count || topology.count || topology.plus_course_count || topology.course_count || 0,
        upcomingCoursesCount: topology.upcoming_count || 0,
        upcomingCoursesThisMonth: topology.upcoming_this_month || 0,
        enrolledCoursesCount: topology.enrolled_count || 0,
        totalSubItem: topology.total_subItem || 0,
        progress: topology.progress || 0,
        color: topology.color,
        plusCourseCount: topology.plusCourseCount || topology.total_count || 0,
        colorCode: topology.color_code,
        level: topology.level,
        fullName: topology.title,
        icon: topology.icon,
        children: topology.children,
        slug: topology.slug || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .getStringWordsJoinedWith */ .kL)(topology.name, "-"),
        parent: topology.parent,
        isPracticeAvailable: topology.is_practice_session,
        isPlusAvailable: topology.is_plus_available,
        isFreeUnavailable: topology.is_free_unavailable,
        language: topology.language || null,
        ogImage: topology.og_image || null,
        window: topology.window,
        windowCount: topology.window_count,
        selfDataFetched: topology.selfDataFetched || false,
        tags: topology.tags,
        isNoTestGoal: !!((ref = topology.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.name) === "NON_TEST_PREP";
        })),
        isIconicAvailable: topology.is_iconic_available,
        externalApps: topology.external_apps_available,
        isSyllabusV1Enabled: topology.is_syllabus_v1_enabled,
        isPlatformGoal: topology.is_platform_goal || false,
        goalLevelOnboarding: {
            isAvailable: topology.is_goal_onboarding_available || false,
            status: topology.user_onboarding_status || null,
            hideNudge: false
        },
        isLeaderdboardMetaInfoAvailable: topology.is_leaderdboard_meta_info_available,
        leaderboardFilters: topology.leaderboard_filters,
        leaderboardScreenMetaInfo: topology.leaderboard_screen_meta_info,
        isCatalogueFeatureAvailable: topology.is_catalogue_feature_available || false,
        isK12: topology.is_k12_goal || false,
        isUaIconGoal: topology.is_ua_icon_goal || false,
        isRecordedGoal: topology.is_recorded_goal,
        isCentreAvailable: topology.is_centre_available
    };
}
function getEntityData(data) {
    return topologyModal(data);
}
var getLink = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid);
};
var getBrowseLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/browse");
};
var getBrowseLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/browse";
};
var getBrowseLink = function(data) {
    return {
        as: getBrowseLinkAs(data),
        href: getBrowseLinkHref()
    };
};
var getPlannerLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/planner");
};
var plannerLink = "/goal/[goalSlug]/[goalUID]/planner";
var getPannerLink = function(data) {
    return {
        as: getPlannerLinkAs(data),
        href: plannerLink
    };
};
/**
 * Retuns link href of a generic goal
 * @returns string pattern of a generic goal href
 */ var getLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]";
};
var getTopicLink = function(topic, goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topic/").concat(topic.uid);
};
var getTopicLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getTopicListLink = function(goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topics");
};
var getTopicListHref = function() {
    return "/goal/goalSlug/goalUID/topics";
};
var getLinkPath = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getSpecialClassesLink = function(data) {
    return "".concat(getLink(data), "/classes");
};
var getSpecialClassesLinkHref = function() {
    return "".concat(getLinkHref(), "/classes");
};
var getSpecialClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes",
        as: "".concat(getLink(data), "/classes")
    };
};
var getGtpFreeClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes/[type]",
        as: "".concat(getLink(data), "/classes/all_classes")
    };
};
var getYoutubeCourseLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]",
        as: "/content/p/freecourses/".concat(data.goalUID)
    };
};
var getYoutubeLessonLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]",
        as: "/content/p/freecourses/".concat(data.goalUID, "/").concat(data.courseTitle, "/").concat(data.courseUID, "/").concat(data.lessonUID)
    };
};
var getHrefAndAsOfAFreeCourse = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/free-platform",
        as: "".concat(getLink(data), "/free-platform")
    };
};
var getHrefAndAsOfSaved = function(goal) {
    return {
        href: "".concat(getLinkHref(), "/saved"),
        as: "".concat(getLink(goal), "/saved")
    };
};
var getCoursesHref = function() {
    return "".concat(getTopicLinkHref(), "/courses");
};
var getCoursesAsPath = function(goalSlug, goalUID, topicUID) {
    return "".concat(getTopicLink({
        uid: topicUID
    }, {
        slug: goalSlug,
        uid: goalUID
    }), "/courses");
};
var _obj;
var getTopologyName = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CATEGORY */ .OP.CATEGORY, "Category"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GOAL */ .OP.GOAL, "Goal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GROUP */ .OP.GROUP, "Topic Group"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.TOPIC */ .OP.TOPIC, "Topic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CONCEPT */ .OP.CONCEPT, "Concept"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.SUBCONCEPT */ .OP.SUBCONCEPT, "Subconcept"), _obj);
var topology = {
    Topology: topologyModal,
    getEntityData: getEntityData,
    getLink: getLink,
    getLinkHref: getLinkHref,
    getSpecialClassesLink: getSpecialClassesLink,
    getLinkPath: getLinkPath,
    getTopicLink: getTopicLink,
    getTopicListLink: getTopicListLink,
    getSpecialClassesAllLink: getSpecialClassesAllLink,
    getHrefAndAsOfAFreeCourse: getHrefAndAsOfAFreeCourse,
    getTopicListHref: getTopicListHref,
    getSpecialClassesLinkHref: getSpecialClassesLinkHref,
    getTopicLinkHref: getTopicLinkHref,
    getHrefAndAsOfSaved: getHrefAndAsOfSaved,
    getTopologyName: getTopologyName
};
/* harmony default export */ __webpack_exports__["ZP"] = (topology);


/***/ }),

/***/ 81570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ isLegendEducator; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "ug": function() { return /* binding */ formatFirstName; }
/* harmony export */ });
/* unused harmony export getRelativeLink */
/* harmony import */ var _utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21848);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);


var formatFirstName = function(firstName) {
    return firstName ? firstName.toLocaleString() : "";
};
var getRelativeLink = function(user) {
    var url = "/learner/@".concat(user.username);
    if (user.is_educator || user.is_moderator) url = user.relative_link || "/@".concat(user.username);
    return url;
};
var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
function userModel(userData) {
    var user = userData.author_details ? userData.author_details : userData;
    var firstName = user.first_name ? user.first_name.toLocaleString() : "";
    var lastName = user.last_name ? user.last_name : "";
    return {
        firstName: firstName,
        lastName: lastName,
        uid: user.uid,
        isFullStoryUser: user.is_full_story_user,
        name: getFullName(firstName, lastName),
        thumbnail: user.avatar_v1 || user.avatar || null,
        description: user.bio || null,
        permalink: user.permalink,
        relativeLink: getRelativeLink(user),
        averageRating: user.avg_rating,
        username: user.username.toLowerCase() || null,
        referralInfo: user.referral_info,
        followersCount: user.followers_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.followers_count) : null,
        followingCount: user.follows_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.follows_count) : null,
        lifetimeViews: user.lifetime_views ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.lifetime_views) : null,
        starRatings: user.star_ratings ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.star_ratings) : null,
        isFollowing: user.is_following,
        postsCount: user.posts_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.posts_count) : null,
        coursesCount: user.courses_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.courses_count) : null,
        isEducator: user.is_educator,
        isModerator: user.is_moderator,
        isVerifiedEducator: user.is_verified_educator,
        isExEducator: user.is_ex_educator,
        isEmailVerified: user.is_email_verified,
        isPhoneVerified: user.is_phone_verified,
        isProfileFilled: user.is_profile_filled,
        isPlatformEducator: user.is_platform_educator,
        isPlatinumEducator: user.is_platinum_educator,
        dedications: user.dedications,
        topicsDisplay: user.topics_display,
        stats: user.stats,
        phone: user.phone,
        email: user.email,
        state: user.state,
        country: user.country,
        language: user.language,
        canAddPlusCourse: user.can_add_plus_course,
        canAddSpecialClass: user.can_add_special_class,
        verifiedEducatorAt: user.verified_educator_at,
        liveMinutes: user.live_minutes ? Math.round(user.live_minutes / 60) : 0,
        totalWatchMins: user.total_watch_time ? Math.round(user.total_watch_time / 60) : 0,
        credentials: user.credentials,
        languages: user.languages,
        becomeEducatorAt: user.become_educator_at,
        educatorType: user.educator_type,
        educatorTypeV2: user.educator_type_v2,
        knowsAbout: user.knows_about,
        levelInfo: user.level_info || {},
        levelId: user.level_id,
        dateJoined: user.date_joined,
        ogImage: user.og_image || null,
        leaderboardMetaInfo: user.leaderboard_meta_info || null,
        avatarV1: user.avatar_v1 || null,
        avatarV2: user.avatar_v2 || null,
        oldAvatar: user.old_avatar || null,
        fallbackAvatar: user.avatar || null,
        queryID: user.queryID,
        requestID: user.requestID,
        index: user.index
    };
}
function getEntityData(data) {
    return userModel(data);
}
var isLegendEducator = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.uid === "WO7LDJ3Y2Z" || data.educatorType === 4;
};
var user = {
    User: userModel,
    getEntityData: getEntityData,
    isLegendEducator: isLegendEducator
};
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 91686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base_H2_H2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39396);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85620);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82034);
/* harmony import */ var _base_ContentsTable_ContentsTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81648);
/* harmony import */ var _base_MenusNav_MenusNav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37957);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47426);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2080);
/* harmony import */ var _layout_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41566);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80867);
/* harmony import */ var _cont_CompanyDetails_LeftContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71750);
/* harmony import */ var _cont_CompanyDetails_RightContainer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69045);
/* harmony import */ var _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27300);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10076);

/* eslint-disable max-lines */ 














var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1jbv1hq0",
    label: "Wrapper"
})("display:flex;flex-direction:column;grid-column:span 24;");
var StyledH3 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H3_H3__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e1jbv1hq1",
    label: "StyledH3"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_6B */ .t8.BY, ";padding-top:100px;margin-top:-100px;");
var Paragraph = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e1jbv1hq2",
    label: "Paragraph"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_4B */ .t8.BM, ";text-align:justify;");
var StyledParagraph = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(Paragraph, {
    target: "e1jbv1hq3",
    label: "StyledParagraph"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_4B */ .t8.BM, ";ol > li{margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_2B */ .t8.Rw, ";&:first-of-type{margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_2B */ .t8.Rw, ";}}");
var LearnerPolicyHeading = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
    target: "e1jbv1hq4",
    label: "LearnerPolicyHeading"
})("text-align:center;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_8B */ .t8.B3, ";");
var StyledOl = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("ol", {
    target: "e1jbv1hq5",
    label: "StyledOl"
})("list-style-type:lower-alpha;");
var Link = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("a", {
    target: "e1jbv1hq6",
    label: "Link"
})();
var ListItem = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledParagraph, {
        as: "li",
        children: children
    });
};
var tableData = [
    {
        label: "Eligibility and Enrolment",
        id: "eligibility_and_enrolment"
    },
    {
        label: "Ranking and Rewards",
        id: "ranking_and_rewards"
    },
    {
        label: "Personal Information",
        id: "personal_information"
    },
    {
        label: "Consent And Waiver By Participants",
        id: "consent_and_waiver_by_participants"
    },
    {
        label: "General Terms and Conditions",
        id: "general_terms_and_conditions"
    },
    {
        label: "Disclaimers",
        id: "disclaimers"
    },
    {
        label: "Contest Specific Terms and Conditions - Unacademy National Scholarship Admission Test (UNSAT)",
        id: "contest_specific"
    },
    {
        label: "FAQs - Offline and online tests",
        id: "faq"
    }
];
var RankPredictorTerms = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_cont_CompanyDetails_LeftContainer__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_MenusNav_MenusNav__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    data: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .menus */ .IJ,
                    currentHref: pathname
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_cont_CompanyDetails_RightContainer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Wrapper, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_H2_H2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: "Unacademy Contests Terms and Conditions"
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_ContentsTable_ContentsTable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                data: tableData
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Paragraph, {
                                children: "Unacademy Contest Term and Conditions (\u201CContest Terms\u201D) is made available to you by M/s Sorting Hat Technologies Private Limited (collectively referred to as \u201Cus\u201D \u201Cwe\u201D \u201CUnacademy\u201D). These Contest Terms govern the relationship between persons who wish to participate in contests that are made available and organized by Unacademy (\u201CContest(s)\u201D) to the users of www.unacdemy.com and/or the Unacademy Apps (referred to as \u201CUnacademy Platform\u201D) either remotely or in person (collectively referred to as \u201Cyou\u201D your(s)\u201D \u201CParticipant(s)\u201D). The Participants and Unacademy shall be collectively referred to as Parties and individually as Party. The terms and conditions and privacy policies and other policies made available on the Unacademy Platform (\u201CPlatform Terms\u201D) shall be valid and binding on all Participants. All capitalized terms not defined herein shall have the meaning assigned to it under the Platform Terms. Unacademy shall from time to time communicate contest specific terms and conditions that shall also be binding on the Participants (\u201CContest Specific Terms\u201D). The Platform Terms, Contest Terms and any other Contest Specific Terms shall collectively be referred to as \u201CTerms and Conditions\u201D. By participating in the Contest, the Participant agrees to be bound by the Terms and Conditions."
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[0].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[0].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "In order to be a Participants in the Contests, the Participants must conform to the following eligibility criteria (unless specified otherwise) in addition to eligibility criteria in the Contest Specific Terms:",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "an Individual;"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "an Indian citizen;"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "in India;"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "legally eligible to enter into a contract;"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "user of the Unacademy Platform;"
                                            })
                                        ]
                                    }),
                                    "The Contests are open to participation by individuals only. Corporate entities, agencies and any non-human legal entities are barred from participating in the Contest. Employees, consultants, interns and educators of Unacademy are not allowed to participate in Contests conducted by Unacademy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Participants may be required to pay a participation or enrolment fee in order to take part in the Contest the details of which shall be as specified in the Contest Specific Terms.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Participants are not bound in any way to participate in the Contests. Any participation is voluntary, and the Contest is being made available purely on a best effort basis. Unacademy, in its sole discretion, reserves the right to disqualify the Participant from the benefits and Rewards of the Contest, if any fraudulent activity is detected or on any breach of the Terms and Conditions by the Participant."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[1].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[1].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "Each Contest shall have its own specific selection criteria, ranking and rewards system as specified in the Contest Specific Terms. Subject to the Contest Specific Terms, Unacademy may, at its sole discretion, choose to reward Participants who won the Contest (\u201CRewards\u201D).",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy reserves the right at its sole discretion to modify, withdraw, suspend, extend, add reschedule or cancel the Contest or the Rewards under the Contests at any time without any prior written notice.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Participants understands that obtaining a high rank in any Contest does not automatically qualify them for Rewards under the Contest and shortlisting of Participants is based on selection parameters of Unacademy set out in the Contest Specific Terms, as determined by Unacademy in its sole discretion.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The shortlisted Participants may be contacted and be required to submit additional information / documentation as may be essential for Unacademy to provision the Rewards. Unacademy does not accept any responsibility for any incorrect and/or incomplete communication details provided and/or delay in receipt of communication and/or non-receipt of communication.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Finally, upon collection and verification of the required documentation (as required), Rewards shall be processed to the shortlisted Participants within timeline as maybe determined by Unacademy at its sole discretion.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall have the sole discretion to reject the Participant or choose another Participant in place of the originally shortlisted Participant if: (a) the documents or details provided by the Participant are invalid/incorrect/incomplete/ misleading /untrue or not acceptable in the opinion of Unacademy; (b) the Participant has not conformed to any of the terms and conditions contained herein; (c) the Participant does not sign the consent form or any other documents required, if any, by Unacademy concerning the Contest; (d) any other reason as may be deemed appropriate by Unacademy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The process of selection, number of Participants shortlisted for the Rewards and the type or form of Reward are to be determined, and shall be subject to change, at the sole discretion of Unacademy and the decision of Unacademy shall be final and binding. The Participants are encouraged to check the Terms on a periodic basis to ensure that they do not miss out on any updates and modifications."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[2].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[2].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "A Participant\u2019s Personal Information, including Sensitive Personal Information, that may be collected to enable the Contest, provide ancillary services related to the Contest and delivery of the Rewards, shall be collected, processed, and stored in accordance with the Unacademy\u2019s Privacy Policy. Participants shall have all the rights available to them under the applicable Data Protection Laws in accordance with the Unacademy Privacy Policy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall use a Participant\u2019s Personal Information for facilitating Contests and rendering the Services with respect to the Platform in the most effective manner, to secure the Platform and make improvements, to perform market research and product analysis, to carry out Unacademy\u2019s obligations towards the Participant, and to communicate with the Participant. The said communication can either be by calls, text, or emails and for the purposes of conducting the Contest itself, transactional, service, advertising or promotional calls or messages about the Contest(s) and other offers, new products or services made available by Unacademy and the Participant hereby consents to the same. Any deletion request received from a Participant in respect of their Personal Information shall be processed in accordance with Unacademy Privacy Policy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Notwithstanding the foregoing, in the event a Participant has already received a Reward prior to a deletion request / withdrawing consent for use of its information, Unacademy shall comply with such request as per the terms of the Privacy Policy, subject to the said Participant refunding/returning the reward received by such Participant pursuant to these Contest Terms."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[3].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[3].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "The Participant hereby consents to the use by Unacademy of his/her name, age, photograph, videos, voice recordings, rank, statements and/or testimonials (\u201CPersonal Attributes\u201D) for the purpose of publication, advertising, promotion on its online platforms, including but not limited to the Unacademy Platform, and through any mode, medium, platform and/or format, including without limitation, in newspapers, magazines, other print media, on television, radio, internet and other electronic and/or in mailings for educational awareness.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any testimonial or statements provided by the Participant and any other details pertaining to the Contest, the Rewards they have won, their use of the Platform, content available on the Platform, shall be exclusively provided to Unacademy and the Participant warrants to that extent.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any marketing material created by Unacademy using a Participant\u2019s Personal Attributes shall remain the sole property of Unacademy, and the Participant shall have no claim of any nature against the same. The Participant understands that the use of his/her Personal Attributes by Unacademy shall be made at its sole discretion without any further notice to the Participant. Unacademy shall have no obligation to consider Participant\u2019s inputs or feedback on the use of his/her Personal Attributes.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Participant shall release, waive, and discharge claims of any kind or nature arising out of or relating to the use of his/her Personal Attributes against Unacademy or any person or firm authorized by Unacademy to publish the same in accordance with the terms hereof. Such release, waiver and discharge shall also extend to all group companies, affiliated companies, subsidiaries, shareholders, directors, officers, employees, agents and assigns of Unacademy and any publishers of the Personal Attributes in accordance with the terms hereof. Such a release shall be binding on the Participant, his/her respective successors, heirs, assigns, executors, administrators, spouse and next of kin.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Participant hereby confirms that the chance provided by Unacademy to be recognized as winner in the Contest(s) and delivery of Rewards if any, in accordance with these Contest Terms, is sufficient consideration for the use of Participant\u2019s Personal Attributes by Unacademy in accordance with the terms hereof, and Unacademy shall have no liability to pay any consideration for any use of the Participant\u2019s Personal Attributes in accordance with these Contest Terms."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[4].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[4].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "Information that is available on the official Contest page or communicated on Unacademy\u2019s official social media handles shall be the only authentic and valid information with respect to the Contests. Unacademy shall not be responsible for any incorrect/misleading information relating to the Contest, presented/ displayed on any other source other than the Contest page on\u202FUnacademy Platform shall not be liable for any loss suffered by any Participants based on the representation, Terms, the information presented/displayed on any other source other than the Contest page on the Unacademy Platform.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "A Participant who has received a Reward for one Contest shall not be eligible for the Reward in the next edition of the same Contest, unless allowed specifically in the Contest Specific Terms. A Participant who has received a Reward under the sub-category of one Contest shall not be eligible for Rewards under another sub-category in the same Content irrespective of the Ranking.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "After the results are announced, Unacademy will conduct a thorough evaluation to determine if the Participants have conducted themselves in accordance with the Terms.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "If at any point in time it is brought to the attention or knowledge of Unacademy that the Participant have engaged in any unethical practices including but not limited to having prior access to the questions in the Contest, usage of any circumventing technology to manipulate the product algorithm or any act which will give the Participant an unfair advantage over other Participants, engaged in any form of mal-practice, Unacademy may at its sole discretion cancel any Reward or reward due to the Participant and bar the Participant for using any product or services offered by Unacademy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "All Rewards are subject to the Participants adhering to the Terms and Conditions and shall be subject to the laws of India, including all the applicable tax laws.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy has endeavored to make all reasonably practicable arrangements to minimize communication system difficulties or any other technical issues but can make no guarantee thereof and shall not be liable for any failures in the same. Unacademy shall not be responsible and/or liable in any manner whatsoever in case the Participant is unable to participate due any technical issues or due to the issues with their internet provider, hardware, facility provider, etc.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any Participant found participating in the Test through multiple accounts or in the event any person impersonates a Participant, such Participant(s) shall be disqualified immediately and shall not be entitled to any Rewards. The Participant shall be barred from participating in any future Contests, tests etc. at the sole discretion of Unacademy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any Participant taking part in Contest and is declared winner in the Contest by Unacademy and is unable to fulfil any one or more eligibility requirements, as specified in the Terms shall be disqualified from receiving any Reward. Any communication, clarification, query, dispute in this regard by the Participant, or any of the legal heirs/guardians of the Participant in any manner shall not be entertained by Unacademy.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy will not be responsible, in case anyone is unable to participate in the Contest on account of not having access to the Contest.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Participant/s winning the Reward/s shall be contacted by Unacademy via email or any other mode of communication. Unacademy shall not be liable for any loss, claim, damage, expenses whether expressed, implied, real, or consequential incurred by the Participant due to participation, non-participation or otherwise in the Contest. Unacademy shall not be liable for any loss that occurs during the dispatch of the Reward to the Participant\u2019s address Unacademy shall not be responsible for paying any applicable taxes, fee, charges, etc. related to the Reward.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any query regarding the Contest will be entertained only for 1 (one) month from date of the participation in the Contest. Post such timeframe, Unacademy will not entertain any correspondence or communication regarding the Contest from any person.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall not be responsible for any deficiency in the Rewards and does not make a representation about the quality, make, performance, features, endurance, finishing, benefits, or fitness of the Rewards and neither does Unacademy endorse the services or goods provided by the manufacturers/service providers of the Rewards.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Any disputes with respect to Contest shall subject to be governed by and construed in accordance with the laws of India, without reference to principles of conflict of laws and the courts in Bangalore shall have the exclusive jurisdiction to determine any disputes arising out of, under, or in relation to, the Contest.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Participant shall indemnify and hold harmless Unacademy, its officers, employees, agents, licensees, etc against any and all damages, claims, losses, demands, actions, causes of action, suits, litigation, costs and expenses (including but not limited to, the publication of response(s) submitted by the Participant as a part of, or in association with the Contest without limitation, reasonable attorneys\u2019 and consultants\u2019 fees).",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall not be liable for any failure to comply with its obligations caused by weather conditions, fire, flood, strike, hurricane, industrial dispute, war, hostilities, terrorist attack, political unrest, riots, civil commotion, inevitable accidents, pandemic and/or epidemic, acts of God or any other circumstances amounting to Force Majeure.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall not be responsible for any loss or damage if Unacademy is required to discontinue or cancel the Contest in compliance with any law, ruling, order, regulation, requirement, or instruction of any Central/State Government or for any other unavoidable reason beyond its control. The Participants shall be informed of such discontinuance/cancellation as early as possible.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The aggregate liability of Unacademy in case of any damage, loss, cost, claim, liability, or expense (including legal costs and expenses) caused to or incurred by any act, omission, or representation in respect of the Reward, shall not exceed any participation or enrolment fee paid for the Contest. Further, Unacademy shall not be liable to share the invoice of the Reward with the Participant at any given point of time whatsoever."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[5].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[5].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "Unacademy and/or its subsidiaries/affiliates shall not be under any obligation to the Participant in relation to the Contest and the Participant shall have no claims whatsoever against Unacademy and/or its subsidiaries/affiliates relating to the selection process, gratification, or the running of the Contest.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall not be responsible for any errors or omissions in the terms and conditions contained herein. All information provided is provided \u201Cas is\u201D without warranty of any kind. To the fullest extent permitted by applicable law, Unacademy disclaims all warranties, express or implied, including without limitation, implied warranties of merchantability, fitness for a particular purpose, and non-infringement in respect of the Contest",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall have the sole discretion to discontinue / cancel the Contest or any part thereof at any point in time and the Participant shall not raise any claim due to such discontinuation or cancellation at any time whatsoever.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "Unacademy shall not be held responsible in case of a server shutdown or loss of Participants\u2019 registration and/or other data. Unacademy shall not be responsible for any delay in receipt or non-receipt or incomplete or corrupt receipt of the registration or, other details of the Participant. Unacademy shall not be responsible for any technical difficulties or data corruption that may arise during the registration process. Further, Unacademy shall not be responsible and/or liable in any manner whatsoever in case the Participant is unable to register for participation in the Contest due to failure on part of the internet service provider, facility provider, etc."
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[6].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[6].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    "The Unacademy National Scholarship Admission Test (\u201CUNSAT\u201D and/or \u201CTest\u201D) is a scholarship test organized by M/s Sorting Hat Technologies Private Limited (\u201CUnacademy\u201D). UNSAT shall be valid only within the territory of India. UNSAT shall be governed by the following terms and conditions as well as the Unacademy Contests Terms and Conditions available on the Unacademy Platform (collectively referred to as \u201CTerms\u201D)",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "UNSAT shall be conducted online (\u201COnline Test\u201D) and offline (\u201COffline Test\u201D) according to the schedule (\u201CTest Schedule\u201D) for Foundation, NEET UG and IIT JEE categories (each a \u201CCategory and collectively the Categories\u201D) as given below:",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                        children: "Offline Test Schedule"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(StyledOl, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                value: "a",
                                                children: "The Offline Tests shall be conducted at several premises including schools with which Unacademy has partnered with on 12th, 13th, 14th October 2022."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                value: "b",
                                                children: "The Offline Tests shall be conducted between 8th October 2022 and 15th October 2022, in multiple cities, as may be determined by Unacademy."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                value: "c",
                                                children: "Whilst there shall be no enrollment fee applicable for the Offline Tests conducted at the offline partner schools, an enrollment fee of INR 99 (Indian Rupees Ninety-Nine only) shall apply for the Offline Tests conducted at any other premises."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                        children: "Online Test Schedule"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    "The Online Tests shall be conducted online, accessible through the web and/or mobile Apps of Unacademy, on the 8th and 15th of October 2022. There shall be an enrollment fee of INR 99 (Indian Rupees Ninety-Nine only) applicable for the Online Tests.",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "A. Eligibility and Participation"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "In order to participate in UNSAT, individuals will have to be student of Class VI, VII, VII IX, X, XI, XII and/or those who have dropped to attempt the official examinations in the Categories. Those participating in UNSAT shall be hereinafter referred to as the \u201CParticipant/s\u201D."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "In order to qualify as a Participant of Tests, individuals shall be required to enroll for UNSAT on the official enrolment page of UNSAT (\u201CContest Page\u201D) on the Unacademy Platform, using their mobile number, and, if applicable, pay an enrolment fee as provided hereinabove. . This fee shall be non-refundable."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "Once the fee is paid, an admit card will be issued to the Participant along with other details related to UNSAT including, date, timing and duration of tests, number of slots available for the Tests (\u201CTest Details\u201D) and, in case of Offline Tests, also details of the centre where the Offline Tests will be conducted (\u201CCentre\u201D). The Test Details will also be made available on the Contest Page."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "In case of the Offline Tests, Unacademy does not in any way represent that the Centres will be in the city/town that a Participant resides in. In the event there are no Centres in the city where the Participants reside in, the Participants may travel to any one of the other cities nearest to the Participant."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "In case of an Offline Test, enrolment shall close at least 4 (four) prior to the date of conducting such Offline Test."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "After the completion of a Test, the Participant shall receive a score and a rank secured in the Test. It is clarified that this rank shall not be final for the purpose of any scholarships or rewards (\u201CRewards\u201D) and all India rank of a Participant (which shall be made notified on or before 21st October 2022 (\u201CFinal Rank\u201D)) shall be considered as relevant for the purposes of Rewards."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "B. Rewards"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                                style: {
                                                    listStyleType: "none"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "1. At the discretion of Unacademy, once the Final Ranks are announced, the Participants may be eligible for one of the following Rewards:"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "a. Up to 100% scholarships for the Participants of the Offline and Online Tests, in the manner, and to the extent, set out below:"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                                        src: "tnc/unsat-table-a.png",
                                                        width: 750,
                                                        height: 500,
                                                        alt: "table"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "2. Participants who have Final Ranks in the IIT JEE Category, may at the sole discretion of Unacademy, and subject to the internal parameters as determined by Unacademy be selected for the Special Rankers\u2019 Group (SRG)"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "3. The Participants will be given their Final Ranks with detailed performance reports on the Tests."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "4. The Rewards shall not be construed as cash rewards or equivalent and cannot be exchanged for cash or kind at any point of time."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "5. The discount for Unacademy Centre subscription or online plus subscriptions on the Unacademy Platform can be availed only for one category and the scholarship cannot be applied to multiple categories or goals."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "6. The Participants shall be required to avail the Rewards on or before 5th November 2022 (\u201CCut-off Date\u201D). The Participants will be required to provide such information as may be requested by Unacademy, for verification of the Participants and enabling the distribution of the Rewards."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "7. The Rewards shall be subject to such other terms and conditions as may be determined by Unacademy at its sole discretion, from time to time."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                        children: [
                                                            "8. 5 (Five) Participants of the Offline Test, who have availed the Reward on or before the Cut-off Date, subject to their performance and the internal parameters as determined by Unacademy, shall be eligible for a special reward (\u201CSpecial Reward\u201D) which shall be a trip to the Euro Space Centre. The Special Reward shall be subject to the following additional terms: ",
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                            " ",
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(StyledOl, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("li", {
                                                                        children: [
                                                                            "The Participant should have become eligible for a Reward and availed the same on or before the Cut-off Date for the Tests conducted for any of the following Categories:",
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                                        children: "Class VI, Class VII, Class VIII, Class IX, Class X,"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                                        children: "Class XI- IIT JEE, Class XI- NEET (UG), Class XI (Board)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                                        children: "Class XII- IIT JEE, Class XII- NEET (UG), Class XII (Board)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                                        children: "Class Dropper- IIT JEE, Class Dropper- IIT JEE"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                        children: "If a Participant is a minor, he / she shall be accompanied by one parent/guardian (\u201CGuardian\u201D) for the trip."
                                                                    }),
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("li", {
                                                                        children: [
                                                                            "The expenses to be borne by Unacademy shall be limited to travel, accommodation, meal expenses, activity expenses (if any), at cost. Any other expenses such as independent, travel, purchases etc. outside of the itinerary set by Unacademy shall be borne by the Participant and Unacademy shall not reimburse the same or entertain any claims to so do.",
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                        children: "The Participants and Guardians may be required to travel to a pre-determined location for the trip and all expenses related to the same shall be borne by the Participants / Guardians. It is hereby clarified that such location shall be within the territory of India subject to availability of flights."
                                                                    }),
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("li", {
                                                                        children: [
                                                                            "The Participants and Guardians shall be required to ensure that they have a valid passport and any other permissions and permits to travel internationally, Unacademy shall at no point of time be required to ensure the same on behalf of the Participants or Guardians.",
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                                        children: "The duration, date and any other details related to the Special Rewards shall be as determined and communicated by Unacademy."
                                                                    })
                                                                ]
                                                            }),
                                                            "The Rewards (including Special Rewards) may be revoked, rescheduled, modified or canceled by Unacademy at any point of time and for any reason whatsoever which shall include without limitation non-availability or flights, accommodation, visas etc. or occurrence of any force majeure event."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "C. Other Terms and Conditions"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "For the Offline Tests, Participants are encouraged to appear at the Centre a minimum of 30 (thirty) minutes before the commencement of the Tests and in the event a Participant is late, he / she will be required to complete the Tests within the remaining time."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "Participants shall not do any act which amount to malpractice or cheating and shall adhere to all the Terms, further the Participants shall obey the instructions of the invigilator or any representative of Unacademy at the Centre and shall not act in any manner that amount to harassment, intimidation or causes general disruption or harm to the other test takers or representatives in the Centre. Further the Participant shall not be allowed to carry any of equipment or material in the Centres."
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                        children: "For the Offline tests, the representatives of Centres and Unacademy shall have the sole discretion to prevent a Participant from entering the Centre or appearing for the Tests. Such representatives shall have sole authority to request a Participant to leave the Centre in case of any act or omission by the Participant that can be deemed to be disruptive (at the sole discretion of such representative). Further such Participants shall be disqualified from the Tests (including any future tests) and shall not be eligible for any Rewards (including Special Rewards)."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(LearnerPolicyHeading, {
                                        children: "UNSAT Learner Referral Policy"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "The Unacademy Learner Referral Program ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CProgram\u201D)"
                                                    }),
                                                    " for the Unacademy National Scholarship Admission Test",
                                                    " ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CUNSAT\u201D)"
                                                    }),
                                                    " is made available, on www.unacademy.com and the Unacademy Apps ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CPlatform\u201D) "
                                                    }),
                                                    "owned and operated by M/s Sorting Hat Technologies Private Limited",
                                                    " ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CUnacademy\u201D)."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "The Program shall be subject to the UNSAT Learner Referral Policy provided herein, the Terms and Conditions and Privacy Policy on the Platform and any other policies as may be communicated from Unacademy periodically ( hereinafter collectively referred to as ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "\u201CTerms\u201D"
                                                    }),
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "The users who have purchased a Plus/Iconic subscription to any category on the Platform ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CLearners\u201D)"
                                                    }),
                                                    " shall be eligible to participate in the Program for the duration as communicated by Unacademy ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CTerm\u201D)"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "Each Learner will be provided with a unique referral code",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CCode\u201D)"
                                                    }),
                                                    " ,made available in the account settings of the Learners account on the Platform, which they can copy and share with their family and friends. The Code shall be available only during the Term."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "Individuals may use the Code at the time of registration for UNSAT on the Platform, it is clarified that this Program is applicable only for the paid online version of UNSAT."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "The Learners will be eligible for a referral reward, in the form of gift vouchers worth INR 75 (Indian Rupee Seventy Five Only) for each successful referral ",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                        children: "(\u201CReward\u201D)"
                                                    }),
                                                    ", subject to the Terms. A successful referral shall mean any individual who uses the Code of the Learner to register for UNSAT by making the requisite payments on the Platform. It is hereby clarified that the Reward shall be disbursed to the eligible Learner in the form of a gift voucher valued at the total consolidated amount that the Learner is eligible for subject to the timelines provided herein only, and Unacademy shall not entertain any requests for exchange or modification of the Reward or any payment is cash or."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "Only registrations using the Code shall be considered for the purpose of Rewards and any failure on the part of the individual to enter the Code at all or the correct Code shall not be the responsibility / liability of Unacademy. Further any failure on part of the Learner to display/share the correct Code shall not be the responsibility / liability of Unacademy. Registrations that have been availed using the Code and then cancelled at the request of the individual shall not be counted for the purpose of payments under this Program. In the rare and exceptional event that Unacademy is required to initiate a refund to the individual for any registrations made using the Code, the same shall not be accounted for at the time of Rewards."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(ListItem, {
                                                children: [
                                                    "The total consolidated Reward shall be disbursed to the Learner within 60 (sixty) days from the expiry of the Term and Unacademy may reach out to the eligible Learners for additional information for the same. In the event the eligible Learner is unable to provide any requested information, the Reward may stand cancelled and/or revoked at the discretion of Unacademy.",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "Learners are prohibited from indulging any unethical activities which shall include but not be limited to (i) making any false representations and promises using the Code (ii) offering any compensation in cash or kind to any individual to use the Code (iii) use any circumventing technologies that will give the Learner undue advantage (iv) use of any paid marketing websites, apps to promote/list the Code (v) any unauthorized use of the trademarks and branding of Unacademy for the purpose of promotions. In the event it is brought to the notice of Unacademy that the Learner has indulged in any unethical practices whether listed here or not, Unacademy reserves the right to take any action that it deems appropriate including cancellation of the Reward, revoking access to accounts and cancellation of subscriptions, without prejudice to any other remedies available to Unacademy under the law."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ListItem, {
                                                children: "Unacademy may, at its sole discretion change, modify, amend these Terms and/or revoke, cancel the Program."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                name: tableData[7].id,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyledH3, {
                                    children: tableData[7].label
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Paragraph, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "Where can I attempt UNSAT?"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Online Exam- Learners can attempt the test online."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Offline Exam- Learners can give the test at designated centres."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h2", {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                            children: "What are the rewards and scholarships for Top Rankers?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Offline Exam - Access to Special Rankers Group, Top Rankers win up to 100% scholarship and a Trip to Euro Space Center.*"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Online Exam- Top Rankers win up to 50% scholarship*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "Where can I download the Admit card? "
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("p", {
                                        children: "You will receive your Admit card via email, 7 days before UNSAT."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h2", {
                                        children: "Who can enroll for UNSAT?"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("p", {
                                        children: "Learners studying in Class 9 to 12 for the academic year 2022-2023 and students pursuing IIT JEE/NEET UG post Class 12 are eligible to take up UNSAT."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "What will the mode of the exam be?"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Online Exam- Website"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                children: "Offline Exam - OMR based offline test"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                                children: "Where can I download the Admit card?"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("p", {
                                        children: "You will receive your Admit card via email; 7 days before UNSAT."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h2", {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                            children: "What is the syllabus and question paper format?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                                        href: "https://unacademy-prod.s3.ap-southeast-1.amazonaws.com/web-cms/UNSAT+Syllabus+%26+Pattern.pdf",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Syllabus.pdf"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h2", {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("b", {
                                            children: "Are there any Mock Tests and courses available to prepare for UNSAT?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("p", {
                                        children: [
                                            "Yes. Find below the links for the Mock Tests and courses.",
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Link, {
                                                            href: "https://unacademy.com/event/testseries/unsat2.0-iitjee",
                                                            target: "_blank",
                                                            children: "Click Here for IIT JEE"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Link, {
                                                            href: "https://unacademy.com/event/testseries/unsat2.0-neetug",
                                                            target: "_blank",
                                                            children: "Click Here for NEET UG"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Link, {
                                                            href: "https://unacademy.com/event/testseries/unsat2.0-k12",
                                                            target: "_blank",
                                                            children: "Click Here for IIT JEE/NEET UG Foundation"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("li", {
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Link, {
                                                            href: "https://unacademy.com/event/testseries/unsat2.0-k12",
                                                            target: "_blank",
                                                            children: "Click Here for Class 9 - 12"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h2", {
                                        children: "What is the Special Rankers Group?"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("br", {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("p", {
                                        children: "It is a special group created for top-performing Learners to increase their chances of ranking in the top 100. The Batches here are curated by Top Educators who mentor and produce AIRs every year."
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
RankPredictorTerms.pageInfo = {
    name: "Unacademy Rank Predictor Terms",
    isMWebSupported: true,
    layoutOptions: {
        hideGoalSelector: true,
        disableDarkMode: true
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RankPredictorTerms);
RankPredictorTerms.Layout = _layout_index__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
RankPredictorTerms.Wrapper = _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_13__["default"];


/***/ }),

/***/ 75982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isScheduleDataForDppFetched; },
/* harmony export */   "nB": function() { return /* binding */ getPreviewMode; }
/* harmony export */ });
/* unused harmony exports getSnackBarContent, getSubscriptionFeatures, getSubscriptionHighlights, getIconicFAQs */
var getSnackBarContent = function(param) {
    var others = param.others;
    return others.snackBarContent;
};
var getPreviewMode = function(param) {
    var others = param.others;
    return others.nextPreviewMode || false;
};
var isScheduleDataForDppFetched = function(param) {
    var others = param.others;
    return others === null || others === void 0 ? void 0 : others.isScheduleDataForDppFetched;
};
var getSubscriptionFeatures = function(param) {
    var others = param.others;
    return others.subscriptionFeatures;
};
var getSubscriptionHighlights = function(param) {
    var others = param.others;
    return others.subscriptionHighlights;
};
var getIconicFAQs = function(param) {
    var others = param.others;
    return others.iconicFAQs;
};


/***/ }),

/***/ 51562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actions_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68060);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85690);
/* harmony import */ var _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97296);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28119);
/* harmony import */ var _actions_constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94336);
/* harmony import */ var _utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74392);
/* harmony import */ var _api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79415);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17912);
/* harmony import */ var _captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28029);













var isRefreshing = false;
var subscribers = [];
var fetchErrorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var error, _action, action, dispatch, getState, _rest, rest, options, headers, endpoint, source, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, accessToken, refreshToken, isServer, response, errorResp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    error = param.error, _action = param.action, action = _action === void 0 ? {
                        type: ""
                    } : _action, dispatch = param.dispatch, getState = param.getState, _rest = param.rest, rest = _rest === void 0 ? {} : _rest, options = param.options, headers = param.headers, endpoint = param.endpoint, source = param.source;
                    ;
                    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 400 && (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) < 600) (0,_captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        endpoint: endpoint,
                        error: error,
                        source: source,
                        options: options,
                        headers: headers
                    });
                    if (!((error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401)) {
                        _ctx.next = 35;
                        break;
                    }
                    ref7 = (0,_getTokens__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getState), accessToken = ref7.accessToken, refreshToken = ref7.refreshToken;
                    isServer = "object" === "undefined";
                    if (!(accessToken && refreshToken)) {
                        _ctx.next = 34;
                        break;
                    }
                    if (isRefreshing) {
                        _ctx.next = 32;
                        break;
                    }
                    if (action.type !== "ME") subscribers.push(action);
                    isRefreshing = true;
                    _ctx.prev = 10;
                    _ctx.next = 13;
                    return (0,_api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchNewToken */ .R$)(refreshToken);
                case 13:
                    _ctx.next = 15;
                    return _ctx.sent.json();
                case 15:
                    response = _ctx.sent;
                    if (!(response === null || response === void 0 ? void 0 : response.error)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error(response === null || response === void 0 ? void 0 : response.error);
                case 18:
                    isRefreshing = false;
                    dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .authenticate */ .YR)({
                        accessToken: response.access_token,
                        refreshToken: response.refresh_token
                    }));
                    _ctx.next = 22;
                    return dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyInfo */ .ct)());
                case 22:
                    subscribers.forEach(function(cb) {
                        return dispatch(cb);
                    });
                    _ctx.next = 29;
                    break;
                case 25:
                    _ctx.prev = 25;
                    _ctx.t0 = _ctx["catch"](10);
                    if (!isServer) {
                        (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                            keepSelectedGoal: true
                        });
                        (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                    }
                    dispatch({
                        type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                    });
                case 29:
                    _ctx.prev = 29;
                    subscribers = [];
                    return _ctx.finish(29);
                case 32:
                    _ctx.next = 35;
                    break;
                case 34:
                    {
                        if (!isServer) {
                            (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                                keepSelectedGoal: true
                            });
                            (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                        }
                        dispatch({
                            type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                        });
                    }
                case 35:
                    if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 429) {
                        _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__/* .utils.open */ .P6.open({
                            message: "Too many requests. Please try again after sometime.",
                            type: "error"
                        });
                    }
                    if (!((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) >= 500 || error.status >= 500)) {
                        _ctx.next = 38;
                        break;
                    }
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: error,
                        type: "".concat(action.type, "_FAILURE")
                    })));
                case 38:
                    _ctx.next = 40;
                    return error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.json();
                case 40:
                    errorResp = _ctx.sent;
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: errorResp,
                        type: "".concat(action.type, "_FAILURE"),
                        statusCode: error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.status
                    })));
                case 42:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                10,
                25,
                29,
                32
            ]
        ]);
    }));
    return function fetchErrorHandler(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchErrorHandler);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12828);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(camelcase_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89875);




/**
 * Fetch with response status check.
 * This function must be wrapped in a try/catch block to catch exceptions.
 * Being used in **worker** space as well.
 * @param {string} url
 * @param {object} options
 * @returns {*} any
 */ var fetchWithoutErrorHandling = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
        var ref, headers, _useCamelCase, useCamelCase, _hasTextResponse, hasTextResponse, _requestType, requestType, _isFormData, isFormData, _body, body, fetchOptions, response, resp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = options || {}, headers = ref.headers, _useCamelCase = ref.useCamelCase, useCamelCase = _useCamelCase === void 0 ? false : _useCamelCase, _hasTextResponse = ref.hasTextResponse, hasTextResponse = _hasTextResponse === void 0 ? false : _hasTextResponse, _requestType = ref.requestType, requestType = _requestType === void 0 ? "GET" : _requestType, _isFormData = ref.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _body = ref.body, body = _body === void 0 ? null : _body;
                    fetchOptions = {
                        method: requestType,
                        headers: headers || {},
                        credentials: "same-origin"
                    };
                    if (false) {}
                    if (body) {
                        try {
                            fetchOptions.body = isFormData ? body : JSON.stringify(body);
                        } catch (e) {
                        /* */ }
                    }
                    _ctx.next = 6;
                    return fetch(url, fetchOptions);
                case 6:
                    response = _ctx.sent;
                    (0,_checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(response);
                    if (!(response.status === 204)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 10:
                    ;
                    if (hasTextResponse) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.prev = 12;
                    _ctx.next = 15;
                    return response.json();
                case 15:
                    resp = _ctx.sent;
                    if (useCamelCase) resp = camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default()(resp, {
                        deep: true
                    });
                    _ctx.next = 21;
                    break;
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](12);
                case 21:
                    _ctx.next = 26;
                    break;
                case 23:
                    _ctx.next = 25;
                    return response.text();
                case 25:
                    resp = _ctx.sent;
                case 26:
                    return _ctx.abrupt("return", resp);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                12,
                19
            ]
        ]);
    }));
    return function fetchWithoutErrorHandling(url, options) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchWithoutErrorHandling);


/***/ }),

/***/ 26951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34497);
/* harmony import */ var _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97487);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17912);






var defaultHost = (0,_utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultHost */ .tW)();
var getHeaders = function(param) {
    var url = param.url, getState = param.getState, _headersOptions = param.headersOptions, _useAuthToken = _headersOptions.useAuthToken, useAuthToken = _useAuthToken === void 0 ? true : _useAuthToken, _useSearchToken = _headersOptions.useSearchToken, useSearchToken = _useSearchToken === void 0 ? false : _useSearchToken, _useJWTToken = _headersOptions.useJWTToken, useJWTToken = _useJWTToken === void 0 ? false : _useJWTToken, _isFormData = _headersOptions.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _useStarGateToken = _headersOptions.useStarGateToken, useStarGateToken = _useStarGateToken === void 0 ? false : _useStarGateToken, headers = param.headers;
    var ref = (0,_getTokens__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(getState), accessToken = ref.accessToken, searchToken = ref.searchToken, JWTToken = ref.JWTToken;
    var apiCallHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, useAuthToken && accessToken ? {
        authorization: "Bearer ".concat(accessToken)
    } : "", useJWTToken && JWTToken ? {
        authorization: "Bearer ".concat(JWTToken)
    } : "", useSearchToken && searchToken ? {
        searchToken: "Bearer ".concat(searchToken)
    } : "", !isFormData && {
        "Content-Type": "application/json"
    }, headers || {});
    var isServer = "object" === "undefined";
    if (url.includes(defaultHost)) {
        var platform = !isServer && _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isMobile */ .Z.isMobile({
            isServer: isServer
        }) ? _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.MOBILE */ .iw.MOBILE : _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.OTHER */ .iw.OTHER;
        apiCallHeaders["X-Platform"] = platform;
    }
    if (useStarGateToken) {
        var stargateJWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getStargateJwtToken */ .$1)(getState());
        apiCallHeaders["Stargate-Token"] = stargateJWTToken;
    }
    return apiCallHeaders;
};
/* harmony default export */ __webpack_exports__["Z"] = (getHeaders);


/***/ }),

/***/ 17912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34497);


var getTokens = function(getState) {
    var accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken", getState);
    var refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken", getState);
    if (true) {
        if (!accessToken) accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken");
        if (!refreshToken) refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken");
    }
    var searchToken = typeof getState === "function" ? (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getSearchToken */ .d6)(getState()) : "";
    var JWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getJwtToken */ .rS)(getState());
    return {
        accessToken: accessToken,
        refreshToken: refreshToken,
        searchToken: searchToken,
        JWTToken: JWTToken
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getTokens);


/***/ }),

/***/ 21848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var parseNumber = function(value) {
    var radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return value && parseInt(value, radix) || 0;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,51656,9720,46571,16050,94336,4392,72047,56015,41566,49774,92888,40179], function() { return __webpack_exec__(43244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);